export const POPUP_DESCRIPTIONS = {
  adminsPage: {
    headlineText: 'Reset account access',
    contentText: 'A new temporary password will be sent to the admin user’s email address on file.',
  },
  lawyersPage: {
    headlineText: 'Reset account access',
    contentText: 'A new temporary password will be sent to the lawyer user’s email address on file.',
  },
  inactiveAccountSignIn: {
    headlineText: 'Account inactive',
    contentText: 'Your account is inactive. Please contact your administrator.',
  },
  deactivateUserAccount: {
    headlineText: 'Deactivate account',
    contentText: 'Are you sure you want to deactivate this user’s account?',
  },
  activateUserAccount: {
    headlineText: 'Activate account',
    contentText: 'Are you sure you want to activate this user’s account access?',
  },
  codesTab: {
    headlineText: 'Are you sure you want to delete this code?',
    contentText: 'This code will be permanently deleted',
  },
  categoriesTab: {
    headlineText: 'Are you sure you want to delete this category?',
    contentText: 'This category will be permanently deleted',
  },
  createDataRequestPage: {
    headlineText: 'Add custom questions',
    contentText: 'Save this data request then edit the saved draft to add custom questions.',
  },
  caseAbandon: {
    headlineText: 'Abandon case',
    contentText: 'Are you sure you want to abandon and archive this case?',
  },
  caseDelete: {
    headlineText: 'Delete case',
    contentText: 'Are you sure you want to delete this case?',
  },
  deductionDelete: {
    headlineText: 'Are you sure you want to delete this deduction?',
    contentText: 'This will affect all data contained in this deduction',
  },
  deductionInvoiceDelete: {
    headlineText: 'Are you sure you want to delete this invoice?',
    contentText: 'This invoice will be permanently deleted.',
  },
  deductionFailedAccountConfirm: {
    headlineText: 'Continue with this payment account?',
    contentText: 'This account’s last transaction was failed. Do you want to proceed?',
  },
  deductionRemittanceDelete: {
    headlineText: 'Delete Remittance Line',
    contentText: 'Are you sure you want to delete this Remittance Line?',
  },
  settlementDelete: {
    headlineText: 'Are you sure you want to delete this settlement?',
    contentText: 'This will affect all data contained in this settlement',
  },
  settlementDraftDelete: {
    headlineText: 'Are you sure you want to delete this settlement draft?',
    contentText: 'This will affect all data contained in this settlement draft',
  },
  caseTypeDelete: {
    headlineText: 'Are you sure you want to delete this case type?',
    contentText: 'This case type will be permanently deleted.',
  },
  questionnaireDelete: {
    headlineText: 'Are you sure you want to delete this questionnaire?',
    contentText: 'This questionnaire will be permanently deleted.',
  },
  formBuilder: {
    headlineText: 'Conditional question.',
    contentText: 'You cannot establish the dependence of a question on itself.',
  },
  formSnippetDelete: {
    headlineText: 'Are you sure you want to delete this snippet?',
    contentText: 'This snippet will be permanently deleted.',
  },
  documentRequestCancel: {
    headlineText: 'Cancel Document Request',
    contentText: 'Are you sure you want to cancel this Document Request? This action cannot be undone.',
  },
  signatureRequestCancel: {
    headlineText: 'Cancel Signature Request',
    contentText: 'Are you sure you want to cancel this Signature Request? This action cannot be undone.',
  },
  dataRequestCancel: {
    headlineText: 'Cancel Data Request',
    contentText: 'Are you sure you want to cancel this Data Request? This action cannot be undone.',
  },
  documentRequestDelete: {
    headlineText: 'Delete Document Request',
    contentText: 'Are you sure you want to delete this Document Request? This action cannot be undone.',
  },
  dataRequestDelete: {
    headlineText: 'Delete Data Request',
    contentText: 'Are you sure you want to delete this Data Request? This action cannot be undone.',
  },
  sessionExpired: {
    headlineText: 'Session Expired',
    contentText: 'Your session is about to expire. You will be logged out in 1 min.',
  },
  trustAccountDelete: {
    headlineText: 'Are you sure you want to delete this account?',
    contentText: 'This account will no longer be available for transactions.',
  },
  unrestrictedAccountDelete: {
    headlineText: 'Are you sure you want to delete this account?',
    contentText: 'This account will no longer be available for transactions.',
  },
  paySettlement: {
    headlineText: 'Are you sure you want to proceed with Plaintiff Pay through v.law?',
    contentText: 'Onboarding Configuration is disabled for your firm, so plaintiff onboarding progress won\'t be tracked with PAY.',
  },
  submitForReview: {
    headlineText: 'Do you want to submit for review?',
    contentText: 'You have unsaved changes. Save them before submitting, or proceed with the last saved details.',
  },
  approval: {
    headlineText: 'Do you want to approve?',
    contentText: 'You have unsaved changes. Save them before approving, or proceed with the last saved details.',
  },
  requestChange: {
    headlineText: 'Do you want to request changes?',
    contentText: 'You have unsaved changes. Save them before requesting changes, or proceed with the last saved details.',
  },
  paySettlementUnsavedChanges: {
    headlineText: 'Do you want to proceed with unsaved changes?',
    contentText: 'You have unsaved changes. Save them before proceeding, or continue with the last saved details.',
  },
};
